import './App.css';
import React from "react";
import HomePage from "./HomePage";
import AboutMe from "./AboutMe";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import ContactMe from './ContactMe';
import Projects from './Projects';



function App() {
  return (
    <div>
      <BrowserRouter>
      <div class= "navbar">
      <button> <Link to= "/"> Home Page </Link> </button>
      <button> <Link to= "/AboutMe"> About Me </Link></button>
      <button> <Link to="/Projects"> Projects </Link></button>
      <button> <Link to="/ContactMe"> Contact Me </Link></button>
      </div>
      
       <Routes>
        <Route exact path= "/" element={<HomePage />} />
        <Route path= "/AboutMe" element={<AboutMe />} />
        <Route path= "/Projects" element={<Projects />} />
        <Route path = "/ContactMe" element={<ContactMe />} />
       </Routes>
       </BrowserRouter>
      </div>
  );
}

export default App;

